import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "./en.js";
import nlLocale from "./nl.js";
import store from "@/store/store";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale
  },
  nl: {
    ...nlLocale
  }
};

const initialLocale = localStorage.getItem("locale") || store.state.common.locale || "en";

store.commit("setLocale", initialLocale);

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "en",
  messages: messages
});

store.watch(
  state => state.common.locale,
  locale => {
    i18n.locale = locale;
    localStorage.setItem("locale", locale);
  }
);


export default i18n;
